import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export function fulfillmentImportCSVModel() {
  const ImportCSV = reactive({
    api: `${apiEndpoint.bcrm_platform}/Fulfillment/Import_TrackingNo`,
    method: "POST",
    xRequest: "",
    payload: {
      uploadFile: null,
    },
  });

  return {
    ImportCSV,
  };
}
